import extractLastOptions from "../../../utils/extract-last-options";

/**
 * Convert divided properties from the cluster to timeline format
 * @param {String} trigger
 * @param {String} property
 * @param {String} parentOptions
 */
const convertPropertyToTimeline = (trigger, property, parentOptions) => {
  /** Get options */
  const data = extractLastOptions(property.slice(0, -1));

  /** Rest of the property string (without options) */
  let rest = `${data.get("rest")})`;

  /** Check if options */
  const hasOptions = data.get("options");

  /** Clean the options from "<>" */
  const sliced = hasOptions?.slice(1, -1) || "";

  /** Get options string */
  const options =
    parentOptions || sliced
      ? `<${[parentOptions, sliced].filter(Boolean).join("░")}>`
      : "";

  /** Keep the `order` option */
  if (hasOptions && /order˸/.test(sliced)) {
    rest = rest.replace(")", `${hasOptions})`);
  }

  return `${trigger}:[[${rest}]${options}]`;
};

export default convertPropertyToTimeline;
